export enum DOM_ID {
    //AUTOPLAY ID'S
    SPINS_TITLE = 'autoplay_modal_no_of_spins_title',
    SPINS_LIST_CONTAINER = 'autoplay_modal_no_of_spins_buttons_container',
    TURBO_MODE_LABEL = 'autoplay_modal_turbo_mode_label',
    TURBO_MODE_CHECKBOX = 'autoplay_modal_turbo_mode',

    BET_LABEL = 'current_bet_label',
    BALANCE_LABEL = 'current_balance_label',

    // RC - GAMEPLAY INFORMATION
    WIN_INFORMATION = 'info_panel_top_line',

    // RC - WINNING INFORMATION
    ADDITIONAL_INFORMATION = 'info_panel_bottom_line',

    // RC - SETTINGS PAGES
    SETTINGS_PAGES_TAB_HOME = 'ui_button_tab_home',
    SETTINGS_PAGES_TAB_INGAME_HISTORY = 'ui_button_tab_in_game_history',
    SETTINGS_PAGES_HEADER_PAYTABLE = 'settings_tab_header_paytable',
    SETTINGS_PAGES_HEADER_HELP = 'settings_tab_header_help',
    SETTINGS_PAGES_HEADER_WINLINES = 'settings_tab_header_winlines',
    SETTINGS_PAGES_HEADER_SETTINGS = 'settings_tab_header_settings',
    PAYTABLE_SPECIAL_SYMBOL_DESCRIPTION = 'paytable_special_symbol_description',
    SETTINGS_SOUND_REEL_STOP_CHECKBOX = 'ui_button_settings_sounds_reel_stop',
    SETTINGS_SOUND_GAMBLE_SHUFFLE_STOP_CHECKBOX = 'ui_button_settings_sounds_gamble_shuffle',
    SETTINGS_SOUND_BACKGROUND_CHECKBOX = 'ui_button_settings_sounds_background',
    SETTINGS_SOUND_MUTEALL_CHECKBOX = 'ui_button_settings_mute_all',
    SETTINGS_LEFT_HAND_CHECKBOX = 'ui_button_settings_left_hand',
    SETTINGS_SHOW_INTRO_CHECKBOX = 'ui_button_settings_show_intro',
    SETTINGS_SHOW_INFO_CHECKBOX = 'ui_button_settings_show_info',
    SETTINGS_WCA_CHECKBOX = 'ui_button_wca_toggle',
    SETTINGS_HISTORY_CHECK_LABEL = 'ui_button_history_check_label',
    SETTINGS_HISTORY_CHECK_BUTTON = 'ui_button_history_check_button',
    SETTINGS_CONTENT_DATA = 'settings_content_data',

    // GENERAL BUTTON'S ID
    BUTTON_DEBUG_PANEL = 'ui_button_debugpanel',
    BUTTON_FULLSCREEN = 'ui_button_fullscreen',
    BUTTON_MENU_PAGES = 'ui_button_menu_pages',
    BUTTON_BET_PLUS = 'ui_button_bet_plus',
    BUTTON_BET_MINUS = 'ui_button_bet_minus',
    BUTTON_SOUND_TRUE = 'ui_button_sound_true',
    BUTTON_SOUND_FALSE = 'ui_button_sound_false',
    BUTTON_TAKE = 'ui_button_take',
    BUTTON_WALLET = 'ui_button_wallet',
    BUTTON_AUTOPLAY_START = 'ui_button_start_autoplay',
    BUTTON_SET_MAX_BET = 'ui_button_set_max_bet',
    BUTTON_MOVIE_PLAY = 'ui_button_play_movie',
    BUTTON_MOVIE_SKIP = 'ui_button_skip_movie',
    BUTTON_CONTINUE = 'preloader_continue_button',

    // FREE SPINS
    BUTTON_FREE_SPIN_TOGGLE = 'ui_button_free_spin_bar_toggle',

    //POPUP MESSAGES
    BUTTON_CLOSE_POPUP_MESSAGE = 'ui_button_close_popup_message',
    BUTTON_POPUP_MESSAGE_FREE_SPINS_ACCEPT = 'ui_button_freespins_popup_message_accept',
    BUTTON_POPUP_MESSAGE_UNIFICIENT_FUNDS_ACCEPT = 'ui_button_unificient_funds_popup_message_accept',
    BUTTON_POPUP_MESSAGE_UNIFICIENT_FUNDS_CASHIER = 'ui_button_unificient_funds_popup_message_cashier',
    BUTTON_POPUP_MESSAGE_LOGOUT_ACCEPT = 'ui_button_logout_confirmation_popup_message_accept',
    BUTTON_POPUP_MESSAGE_LOGOUT_DECLINE = 'ui_button_logout_confirmation_popup_message_decline',

    // MISC
    PRELOADER_CONTAINER = 'ui_preloader',
    CHECKBOX_LOACL_STORAGE = 'ui_checkbox_local_storage',
    CHECKBOX_WCA_PRERLOADER = 'ui_checkbox_wcamode_preloader',
    CHECKBOX_SOUND_PRERLOADER = 'ui_checkbox_sound_preloader',

    // IN GAME HISTORY PANEL
    BUTTON_CLOSE_INGAME_HISTORY_PANEL = 'ui_button_close_ingame_history_panel',
    BUTTON_PREV_INGAME_HISTORY_PANEL = 'ui_button_prev_ingame_history_panel',
    BUTTON_NEXT_INGAME_HISTORY_PANEL = 'ui_button_next_ingame_history_panel',
    BUTTON_PLAY_ROUNDS_INGAME_HISTORY_PANEL = 'ui_button_play_rounds_ingame_history_panel'
}
